// extracted by css-extract-rspack-plugin
export default {"icon":"product-detail-fragment__ProductLocation_icon__+vFac"};